import { getScoreColor } from 'utils/ranking';
import { FishbonePin } from './FishbonePin';

import './FishbonePoint.sass';

// Garde-fous de taille pour la zone de survol invisible centrée sur la sous-arête.
// Volontairement généreuse : la cible doit être facile à viser même quand le
// curseur tombe entre deux pastilles, sans pour autant déborder largement sur la
// pastille suivante (sinon on viserait la mauvaise sous-arête).
const HIT_WIDTH_MIN = 60;
const HIT_WIDTH_MAX = 220;
const HIT_HEIGHT = 34;

export const FishbonePoint = (props: any) => {
	const color = getScoreColor(props.trend);

	let size = Math.min(8, props.size);

	// L'effet ripple n'apparaît que pour les nouveaux éléments (isAppearing)
	// isAppearing est géré par FishboneBranchContent

	// Pendant un drag d'item, on calcule de quel côté du MILIEU de la cible se
	// trouve le curseur : moitié « avant » (index plus petit) -> insérer AVANT,
	// moitié « après » -> insérer APRÈS. L'axe d'ordonnancement des sous-arêtes
	// est l'axe X (l'index croît avec posX), on compare donc l'abscisse locale.
	const reportTarget = (e: React.MouseEvent) => {
		if (!props.draggingItem || props.draggingItem.id === props.id || !props.onItemDragEnter) return;
		const rect = (e.currentTarget as SVGGraphicsElement).getBoundingClientRect();
		const side: 'before' | 'after' = e.clientX < rect.left + rect.width / 2 ? 'before' : 'after';
		props.onItemDragEnter(props.id, side);
	};

	// Surlignage : la sous-arête est cible, et le trait d'insertion se place du
	// côté indiqué (avant/après) pour montrer où l'élément atterrira au drop.
	const isTarget = props.isDropTarget;
	const insertSide = isTarget ? props.dropTargetSide : null;

	return (

		<g
			className={`FishbonePoint ${props.isMatching ? "matching" : ""} ${props.isAppearing ? "appearing ripple" : ""} ${isTarget ? "drop-target" : ""} ${props.draggingItem?.id === props.id ? "dragging" : ""}`}
			transform={`translate(${props.x}, ${props.y})`}
			style={{ cursor: 'grab' }}
			onClick={() => props.onSelectItem(props)}
			onDoubleClick={(e) => { e.stopPropagation(); props.onEdit && props.onEdit(props); }}
			onMouseDown={(e) => {
				if (props.onStartDragItem) props.onStartDragItem(props, e);
				e.stopPropagation();
			}}
		>
			{/* Aura pour l'effet ripple orange */}
			<foreignObject className="aura" width={120} height={120} x={-60} y={-60}>
				<div></div>
			</foreignObject>

			<g>
				<FishbonePin weight={props.weight} color={color} trend={props.trend} completion={props.completion} />

				<text
					fontSize={12}
					fill={props.selected ? "orange" : "var(--ant-color-text)"}
					dy={size * 0.6}
					dx={21}
				>
					{props.name}
				</text>

			</g>

			{/* Indicateur de point d'insertion (trait) : affiché AVANT le drop, sans
			    reflow de la liste, pour montrer où l'élément va atterrir. */}
			{insertSide && (
				<line
					className="insertion-indicator"
					x1={insertSide === 'before' ? -10 : 32}
					x2={insertSide === 'before' ? -10 : 32}
					y1={-12}
					y2={12}
					stroke="#24CCB8"
					strokeWidth={3}
					strokeLinecap="round"
					pointerEvents="none"
				/>
			)}

			{/* Zone de survol invisible centrée sur la sous-arête : pendant un drag
			    d'item elle capte le curseur et détermine le côté avant/après. Sa
			    largeur suit l'écart entre pastilles (slot) pour que chaque
			    sous-arête « possède » son créneau et qu'on vise la bonne. Désactivée
			    hors drag (pointerEvents none) pour ne pas gêner clic/sélection. */}
			{(() => {
				const slot = Math.hypot(props.slotWidth || 0, props.slotHeight || 0);
				const hitWidth = Math.max(HIT_WIDTH_MIN, Math.min(HIT_WIDTH_MAX, slot || HIT_WIDTH_MIN));
				return (
					<rect
						className="drop-hit-area"
						x={-hitWidth / 2 + 4}
						y={-HIT_HEIGHT / 2}
						width={hitWidth}
						height={HIT_HEIGHT}
						fill="transparent"
						pointerEvents={props.draggingItem ? 'all' : 'none'}
						onMouseEnter={reportTarget}
						onMouseMove={reportTarget}
					/>
				);
			})()}
		</g>
	);
};
